import { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../../Assets/Styles/navbar.css';
import Dropdown from 'react-bootstrap/Dropdown';
import styled from "styled-components";
import {Link} from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import {SidebarData} from "./SidebarData";
import SubMenu from "./SubMenu"; 
import {IconContext} from "react-icons/lib";
import Modal from 'react-bootstrap/Modal';
/*import logo from "../../Assets/Images/energy_guru_logo.jpg";*/
/*import logo from "../../Assets/Images/energy_guru_logo_new.png";*/
//import logo from "../../Assets/Images/Bhuhit_Logo_1.png"; 
import logo from "../../Assets/Images/Bhuhit_Logo_2025.png";// Updated on 20260626
//import { asyncFetchData } from "../Axios/AxiosFetchData";
import AxiosInstance from '../Axios/AxiosInstance';
import Axios from "axios";
import { handleGeneralError } from '../ErrorHandler/errorHandler';
import { ErrorLog } from "../Monitoring/ErrorLog";
//*** Set Axios Default BaseURl
 //Axios.defaults.baseURL = "https://localhost:7248";
//Axios.defaults.baseURL = "https://bhuhit.com/api";
const Nav = styled.div`
 /* background:#EFFD90*//*#f0e891*//*#f7e98e*//*#f9f8e1*//*#fffde9*//*#fcf8be*//*#f2f27a*//*#15171c*/;
  background:#fff; /*linear-gradient(to left, #FFFB7D, #85FFBD)*/
  height: 75px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position:relative;
`;
const NavIcon = styled(Link)`
  margin-left: 2rem;
  font-size: 2rem;
  height: 60px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

//const SidebarNav = styled.nav`
// /* background: linear-gradient(to left,green, black);*/
//  background:#99cc33;/*darkslategrey*//*#00d4ff*//*#00573F*//*#008B8B*//*#0D98BA*//*#cdf214*//*#20B2AA*//*#808000*//*#01411C*//*#004953*//*#01796F*//*#444C38*//*#008080*//*#006241*//*#18453B*//*#317873*//*#4A5D23*//*#008B8B*//*#4B5320*//*Olive*//*#006C4F*//*#00AED6*/;
//  width: 250px;
//  height:100vh;
//  display: flex;
//  justify-content: center;
//  position: fixed;
//  top: 0;
//  left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
//  transition: 350ms;
//  z-index: 10;
//  color:#000;
// `;
const SidebarNav = styled.nav`
  background:#99cc33;
  width: 250px;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
  transition: 350ms;
  z-index: 10;
  color:#000;
  overflow-y: auto;
`;

//const SidebarWrap = styled.div`
//  width: 100%;
//`;
const SidebarWrap = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 50px;
`;

const Sidebar = () => {
    const [sidebar, setSidebar] = useState(false);
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [isLoggedIn, setisLoggedIn] = useState(false);
    const [isCloudStatus, setCloudStatus] = useState(false);
    const showSidebar = () => setSidebar(!sidebar);
    const srUserName = sessionStorage.getItem("username");
    const srPlantID = sessionStorage.getItem("user_plantid");
    const srtoken=sessionStorage.getItem("token");
    const [username, setUsername] = useState("");
    const [token, settoken] = useState("");
    const [count, setCount] = useState(0);
    const renderusername = () => { setUsername(srUserName) };
    //** To Check internet connection is on or off **//
    useEffect(() => {
        // Update network status
        const handleStatusChange = () => {
            setIsOnline(navigator.onLine);
        };
        // Listen to the online status
        window.addEventListener('online', handleStatusChange);
         //Listen to the offline status
        window.addEventListener('offline', handleStatusChange);
     
        // Specify how to clean up after this effect for performance improvment
        return () => {
            window.removeEventListener('online', handleStatusChange);
            window.removeEventListener('offline', handleStatusChange);
        };
    }, [isOnline]);
   //** End to check innternet connectivity is on or off **//

   // setInterval(checkCloudConnectivity, 10000);
    useEffect(() => {
        // If internet connection is on then will check cloud database connectivity
      if (isOnline) {
        //Implementing the setInterval method
         // const interval = setInterval(() => {
          const response = AxiosInstance.get("/CloudConnectivityStatus") //AxiosInstance.get("/CloudConnectivityStatus");
             //const response = Axios("/CloudConnectivityStatus");
            //const response = Axios("http://bhuhit.com/api/CloudConnectivityStatus");
              try {
                  response.then((res) => {
                      
                           setCloudStatus(true);
                          //else if (res.data === 'unSuccess') {
                          //    setCloudStatus(false);
                          //    showWarningBox("dvWarningBox", "0", "The cloud database connectivity is not connected."); 
                          //}
                          //console.log("OK: The cloud connectivity request was successful, and the server responded with the requested data.")
                          //handleGeneralError(srPlantID, 0, "Sidebar.js", "useEffect", 200, "OK:The cloud connectivity request is successful.", "CLOUD_CONNECTIVITY", "03", "www.bhuhit.com", "SE-F-1000");
                     // }
                      //else if (res.status === 201) {
                      //    console.log("CREATED:The cloud connectivity request was successful, and a new resource was created.")
                      //    handleGeneralError(srPlantID, 0, "Sidebar.js", "useEffect", 201, "Created:The cloud connectivity request is successful, and a new resource was created.", "CLOUD_CONNECTIVITY", "03", "www.bhuhit.com", "SE-F-1000");
                      //}
                      //else if (res.status === 204) {
                      //    console.log("NO CONTENT:The cloud connectivity request was successful, but there is no content to send in the response.")
                      //    handleGeneralError(srPlantID, 0, "Sidebar.js", "useEffect", 204, "NO CONTENT:The cloud connectivity request was successful, but there is no content to send in the response.", "CLOUD_CONNECTIVITY", "03", "www.bhuhit.com", "SE-F-1000");
                      //}
                      
                  })
                  response.catch(
                      function (error) {
                          setCloudStatus(false);
                         // handleAxiosError(srPlantID, 0, "Sidebar.js", "useEffect", "CLOUDCONNECTVITYERROR", "NO CONTENT:The cloud connectivity request was successful, but there is no content to send in the response.", "CLOUD_CONNECTIVITY", "01", "www.bhuhit.com", "SE-F-1000");
                          // 4xx is client error
                          //if (error.status === 400) {
                          //    console.log("Bad Request: The server could not understand the request due to invalid syntax.")
                          //    console.log(error.request.url);
                          //}
                          //else if (error.response.status === 401) {
                          //  console.log("Unauthorized: The client must authenticate itself to get the requested response.")
                          //}
                          //else if (error.response.status === 403) {
                          //  console.log("Forbidden: The client does not have access rights to the content.")
                          //}
                          //else if (error.response.status === 404) {
                          //  console.log("Not Found: The server cannot find the requested resource.")
                          //}
                          //// 5xx is server side error
                          //else if (error.response.status >= 500) {
                          //    console.log("Internal Server Error: The server encountered an unexpected condition that prevented it from fulfilling the request.")
                          //    const errorMessage = handleError({
                          //        type: "Internal Server Error",
                          //        error,
                          //    });
                          //}
                          if (error.response) {
                              // The request was made and the server responded with a status code
                              console.log(error.response.status);
                              console.log(error.response.data);
                          } else if (error.request) {
                              //error.request is populated when the error occurs due to a problem with the request itself, such as:
                              // 1. Network errors: When the request cannot be sent due to a network issue.
                              // 2. Timeout errors: When the request takes longer than the specified timeout.
                              // 3. Cancellation errors: When the request is cancelled using CancelToken.
                              // The request was made but no response was received
                                console.log('Request error:', error.request);
                                console.log('Request URL:', error.request.url);
                                console.log('Request method:', error.request.method);
                          } else {
                              // Something happened in setting up the request that triggered an Error
                              console.log('Error', error.message);
                          }
                          //console.log('Error Message:' + error)
                          // return Promise.reject(error)
                      }
                  )
              }
              catch (error) {
                  console.log("Error:" + error)
              }
            /*}, 8000);*/
        //Clearing the interval
        //return () => clearInterval(interval);
      }

    }, [isCloudStatus]);

   //Updated code on 20240202,sidebar will refresh when user have login.
    useEffect(() => {
        const interval = setInterval(() => {
            if (isLoggedIn === false) {
                setisLoggedIn(true)
            }
            else if (isLoggedIn === true) {
                setisLoggedIn(false)
            }
        }, 5000);
        //Clearing the interval
        return () => clearInterval(interval);
    }, [isLoggedIn]);

    //** Logout user **//
    const logout = () => {
        LogoutUser();
        showSidebar();
        sessionStorage.clear();
        //localStorage.clear();
        window.location.href = "#/Login";
    }
     
    //** Logout user **//
    const LogoutUser = () => {
        var user_id = sessionStorage.getItem("user_id");
        var plant_id = sessionStorage.getItem("user_plantid");
        if (user_id != null) {
            const response = AxiosInstance.get("#/Logout?uid="+ user_id +"&pid=" + plant_id +"");
            //const response = Axios("https://bhuhit.com/api/Logout?uid=" + user_id + "&pid=" + plant_id + "");
            response.then((res) => {
                console.log("User Logout Sucessfully")
            })
            response.catch(
                function (error) {
                    //setCloudStatus(false);
                    console.log('Error Message:' + error.message)
                   // return Promise.reject(error)
                }
            )
        }
    }
    // Display Operation Modal Popup
    function showWarningBox(dvInfoBox, robotID, errorMessage) {
        //setIsModalOpen(true);
        var divmodal = document.getElementById(dvInfoBox);
        var lblMsg = document.getElementById("lblCriticalWarnMsg" + robotID);
        divmodal.scrollIntoView();
        divmodal.style.display = "block";
        lblMsg.value = errorMessage;
        //setSentCommandButtonActive("btnGetMore" + robotID, robotID, "divGetMore" + robotID, "SendCommand")
    };
    // Hide Operation Modal Popup  
    const hideWarningBox = (dvInfobox) => {
        //setIsModalOpen(false);
        var dvimodal = document.getElementById(dvInfobox);
        dvimodal.style.display = "none";
    };
    const PlantRobotOperation = () => {
        window.location.href = "/#/RobotsOperation?pid="+srPlantID+"";
    }
        return (
            <>
                <IconContext.Provider value={{color: "#e0e0e0" }}>
                    <Nav>
                        <img className="logo_2" src={logo}/>
                        <NavIcon to="#">
                            {/*<FaIcons.FaBars />*/}
                            <FaIcons.FaBars onClick={showSidebar} />
                        </NavIcon>
                        <h1
                            style={{
                                textAlign: "center",
                                marginLeft: "6%",
                                color: "#004953"
                            }}
                        >
                            <div class="container-fluid p-2 text-center">
                               {/* <h2>Robotics Operation & Monitoring System</h2>*/}
                                <h2>Bhuhit</h2>
                            </div>
                        </h1>
                        
                        <div className="user">
                            <Dropdown class="user">
                                {/*<Dropdown.Toggle variant="">*/}
                                {/*    <i class="fa fa-bell" style={{ color: '#99cc33' }}></i>*/}
                                {/*</Dropdown.Toggle>*/}
                                {isLoggedIn === false || isLoggedIn === true ? (
                                    <Dropdown.Menu>
                                        {/*<div class="error_popup"><ErrorLog></ErrorLog></div>*/}
                                        {/*<Dropdown.Item href="#/ErrorLog"> */}
                                        {/*    <i class="fa fa-bell" style={{ color: '#99cc33' }}></i> Error Log*/}
                                        {/*</Dropdown.Item>RobotsOperation*/}
                                        {/*<Dropdown.Item href="#/RobotOperation">*/}
                                        {/*    <i class="fa fa-gears" style={{ color: '#99cc33' }}></i> Robots Operation*/}
                                        {/*</Dropdown.Item>*/}

                                    {/*    <Dropdown.Item href="#/CompletedCommandsStatus">*/}
                                    {/*        <i class="fa fa-gears" style={{ color: '#99cc33' }}></i> Completed Commands Status*/}
                                    {/*    </Dropdown.Item>*/}
                                    {/*    <Dropdown.Item href="#/PendingCommandsStatus">*/}
                                    {/*        <i class="fa fa-gears" style={{ color: '#99cc33' }}></i> Pending Commands Status*/}
                                    {/*    </Dropdown.Item>*/}
                                        {/*<Dropdown.Item href="#/CurrentBatteryStatus">*/}
                                        {/*    <i class="fa fa-battery" style={{ color: '#99cc33' }}></i> Robots Current Battery Status*/}
                                        {/*</Dropdown.Item>*/}
                                        {/*<Dropdown.Item href="#/RobotLocation">*/}
                                        {/*    <i class="fa fa-map-marker" style={{ color: '#99cc33' }}></i> Robot location*/}
                                        {/*</Dropdown.Item>*/}
                                        {/*<Dropdown.Item href="#/RobotsBroadcastStatus">*/}
                                        {/*    <i class="fa fa-signal" style={{ color: '#99cc33' }}></i> Current Robot Connected Status*/}
                                        {/*</Dropdown.Item>*/}

                                    {/*    <Dropdown.Item href="#">*/}
                                    {/*        <i class="fa fa-cloud" style={{ color: '#99cc33' }}></i> Current Weather Status*/}
                                    {/*    </Dropdown.Item>*/}
                                    {/*    <Dropdown.Item href="#">*/}
                                    {/*        <i class="fa fa-user" style={{ color: '#99cc33' }}></i> User Logged Status*/}
                                    {/*    </Dropdown.Item>*/}
                                    {/*    <Dropdown.Item href="#">*/}
                                    {/*        <i class="fa fa-user" style={{ color: '#99cc33' }}></i> Customer User Logged Status*/}
                                    {/*    </Dropdown.Item>*/}
                                    </Dropdown.Menu>
                                ) : (<></>)
                                }
                            </Dropdown>
                        </div>
                        {/*<div className="user column">*/}
                        {/*    <Dropdown class="user">*/}
                        {/*        <Dropdown.Toggle variant="">*/}
                        {/*            <i class="fa fa-tasks" style={{ color:'#99cc33'}}></i>*/}
                        {/*        </Dropdown.Toggle>*/}
                        {/*        {isLoggedIn === false || isLoggedIn === true ? (*/}
                        {/*            <Dropdown.Menu>*/}
                        {/*                <Dropdown.Item href="#/RobotsOperation?pid=1">*/}
                        {/*                    <i class="fa fa-gears" style={{ color: '#99cc33' }}></i><a style={{ cursor: "Pointer" }} onClick={PlantRobotOperation}> Plant Robots Operation</a> */}
                        {/*                </Dropdown.Item>*/}
                        {/*                <Dropdown.Item href="#/CurrentPlantLevelGrassCutting">*/}
                        {/*                    <i class="fa fa-sitemap" style={{ color:'#99cc33' }}></i> Current Plant Level Grass Cutting*/}
                        {/*                </Dropdown.Item>*/}
                        {/*                <Dropdown.Item href="#/CurrentPlantLevelSpraying">*/}
                        {/*                    <i class="fa fa-shower" style={{ color: '#99cc33' }}></i> Current Plant Level Spraying*/}
                        {/*                </Dropdown.Item>*/}
                        {/*                <Dropdown.Item href="#/CurrentRobotsLevelGrassCutting">*/}
                        {/*                    <i class="fa fa-sitemap" style={{ color: '#99cc33' }}></i> Current Robot Level Grass Cutting */}
                        {/*                </Dropdown.Item>*/}
                        {/*                <Dropdown.Item href="#/CurrentRobotsLevelSpraying">*/}
                        {/*                    <i class="fa fa-shower" style={{ color: '#99cc33' }}></i> Current Robot Level Spraying */}
                        {/*                </Dropdown.Item>*/}
                        {/*                <Dropdown.Item href="#">*/}
                        {/*                    <i class="fa fa-server" style={{ color: '#99cc33' }}></i> Robots Operation Sheduling*/}
                        {/*                </Dropdown.Item>*/}
                        {/*            </Dropdown.Menu>*/}
                        {/*        ) : (<></>)*/}
                        {/*        }*/}
                        {/*    </Dropdown>*/}
                        {/*</div>*/}
                        <div className="user column">
                            {
                                isCloudStatus && isOnline ? (
                                    <i class="fa fa-cloud-upload" style={{ color: '#99cc33' }}>&nbsp;Cloud</i>
                                ) :
                                    (
                                        <i class="fa fa-cloud" style={{ color: '#f2971f' }}>&nbsp;Cloud</i>
                                    )
                            }
                        </div>
                        {/*<div className="user column">*/}
                        {/*    {*/}
                        {/*        isOnline ? (*/}
                        {/*            <i class="fa fa-rss" style={{ color:'#99cc33' }}>&nbsp;Net</i>*/}
                        {/*        ) :*/}
                        {/*            (*/}

                        {/*                <i class="fa fa-rss" style={{ color: '#f2971f' }} >&nbsp;NET</i>*/}
                        {/*            )*/}
                        {/*    }*/}
                        {/*</div>*/}
                        {/*<div className="user column">*/}
                        {/*    <Dropdown.Item href="#/RobotLocation">*/}
                        {/*        <i class="fa fa-map-marker" style={{ color: '#99cc33' }}></i>*/}
                        {/*    </Dropdown.Item>*/}
                        {/*</div>*/}
                        <div className="user column">
                            <Dropdown class="user">
                                
                                <Dropdown.Toggle variant="">
                                    {isLoggedIn === false || isLoggedIn === true ? (
                                        <a onClick={renderusername}>{/*{srUserName}*/}</a>
                                    ) :
                                        (
                                            <div></div>
                                          /*  <a onClick={renderusername}>Hi, Guest</a>*/
                                        ) 
                                    }
                                </Dropdown.Toggle>
                               
                                <Dropdown.Menu>

                                    {/*{ isLoggedIn === false  (*/}
                                    {/*    <Dropdown.Item href="#">*/}
                                    {/*        <i class="fa fa-email" style={{ color: '#99cc33' }}></i> Hi, Guest*/}
                                    {/*    </Dropdown.Item>*/}
                                    {/*)*/}
                                    {/*}*/}

                                   {/* {isLoggedIn === false || isLoggedIn === true ? (*/}
                                   {/*     <Dropdown.Item href="#">*/}
                                   {/*         <i class="fa fa-email" style={{ color:'#99cc33' }}></i> {srUserName}*/}
                                   {/*     </Dropdown.Item>*/}
                                   {/* ) :*/}
                                   {/* (*/}
                                   {/*     <Dropdown.Item href="#">*/}
                                   {/*         Hi, Guest*/}
                                   {/*     </Dropdown.Item>*/}
                                   {/* ) */}
                                   {/*}*/}
                                  {srtoken ? (
                                   <div>
                                    
                                    {/*<Dropdown.Item href="#/CurrentBatteryStatus">*/}
                                    {/*   <i class="fa fa-dashboard" style={{ color: '#99cc33' }}></i>&nbsp;Battery Status*/}
                                    {/*</Dropdown.Item>*/}
                                    {/*<Dropdown.Item href="#/RobotsBroadcastStatus">*/}
                                    {/*    <i class="fa fa-signal" style={{ color: '#99cc33' }}></i>&nbsp;Robot Connected Status*/}
                                    {/*</Dropdown.Item>*/}
                                   <Dropdown.Item>
                                    <a onClick={renderusername}>{srUserName}</a>
                                   </Dropdown.Item>
                                   <Dropdown.Item  onClick={logout}>
                                        <i class="fa fa-lock" style={{ color: '#99cc33' }}></i> <a style={{ cursor: "Pointer" }} onClick={logout}>&nbsp;Logout</a>
                                    </Dropdown.Item>
                                    {/*<Dropdown.Item href="#/ErrorLog">*/}
                                    {/*    <i class="fa fa-warning" style={{ color: '#99cc33' }}></i>&nbsp;Error Log*/}
                                    {/*    </Dropdown.Item>*/}
                                   </div>
                                    ) :
                                    (
                                        <Dropdown.Item href="#/Login">
                                                <i class="fa fa-user" style={{ color: '#99cc33' }}></i>&nbsp;Login
                                        </Dropdown.Item>
                                    )
                                  }
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </Nav>
                    {srtoken ==='Admin'? (
                        <SidebarNav sidebar={sidebar} style={{ color:'black'}}>
                            <SidebarWrap style={{
                                overflow: "scroll"
                            }}>
                                <NavIcon to="#" >
                                    <AiIcons.AiOutlineClose onClick={showSidebar} />
                                    {/*<AiIcons.AiOutlineClose onClick={showSidebar} />*/}
                                </NavIcon>
                                {SidebarData.map((item, index) => {
                                    return <SubMenu item={item} key={index} style={{
                                        overflow: "scroll"
                                    }}  />;
                                })}
                            </SidebarWrap>
                        </SidebarNav>
                    ) : (<></>)
                    }
                    <div id={"dvWarningBox"} class="modalcontainer">
                        <Modal.Dialog size="lg"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                        >
                            <Modal.Header closeButton onClick={() => hideWarningBox("dvWarningBox")}>
                                <Modal.Title>
                                    Information Box
                                </Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                                <p>
                                    <label id={"lblCriticalWarnMsg"}></label>
                                </p>
                                <p>&nbsp;</p>
                            </Modal.Body>

                        </Modal.Dialog>
                    </div>
                </IconContext.Provider>
            </>
        );
    };
  
export default Sidebar;
